import { ApiError, type HttpMethod, requestJson } from "@unizpay/ui";

export type AdminRole = "owner" | "admin" | "viewer";

export interface Me {
  id: string;
  email: string;
  name: string | null;
  role: AdminRole;
}

export interface RelayerBalance {
  chain_id: string;
  name: string;
  family: "evm" | "solana" | "tron";
  testnet: boolean;
  enabled: boolean;
  symbol: string;
  address: string | null;
  explorer_url: string | null;
  balance: string | null;
  usd: string | null;
  low: boolean;
  resources?: { energy: string; bandwidth: string };
  error: string | null;
}

export interface RelayerBalances {
  networks: RelayerBalance[];
  checked_at: string;
}

let onUnauthorized: (() => void) | null = null;

/** Called whenever an admin API request returns 401 (signed out or the session expired). */
export function setUnauthorizedHandler(fn: () => void) {
  onUnauthorized = fn;
}

function request<T>(method: HttpMethod, path: string, body?: unknown): Promise<T> {
  return requestJson<T>(method, `/admin-api${path}`, {
    body,
    // A wrong password at sign-in is a 401 too: that is not a lost session.
    onUnauthorized: path === "/auth/login" ? undefined : () => onUnauthorized?.(),
  });
}

export const api = {
  login: (email: string, password: string) =>
    request<{ ok: true }>("POST", "/auth/login", { email, password }),
  logout: () => request<{ ok: true }>("POST", "/auth/logout", {}),
  me: () => request<Me>("GET", "/me"),
  relayers: () => request<RelayerBalances>("GET", "/relayers"),
};

export { ApiError };
